import { Component, OnInit } from "@angular/core";
import {
  RouterEvent,
  NavigationStart,
  NavigationEnd,
  Router,
} from "@angular/router";
import { map, filter } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.handleRouteNavigation();
  }

  private handleRouteNavigation() {
    /* 
      RouterEvent is type Event_2 which is wrong, map is used to
      force the right type https://github.com/angular/angular/issues/43124
    */
    this.router.events
      .pipe(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        map((event: any) => event.routerEvent as RouterEvent),
        filter(
          (event) =>
            event instanceof NavigationStart || event instanceof NavigationEnd
        )
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          console.log(`Router navigation start to ${event.url}`);
        } else {
          const regex = /^\/[^/?]*/;

          const substringRouteOnly = event.url.match(regex);

          if (substringRouteOnly) {
            console.log(`Router navigation end to ${event.url}`);
          }
        }
      });
  }
}
